import * as React from "react";
import { NavigationStep } from "../../types";
import DobAgeProvider from "../../../components/DobAgeProvider";
import PhoneNumberDisplay from "../../../components/PhoneNumberDisplay";
import { Link } from "react-router-dom";
import { Patient } from "../types";
import { User, canManagePatients } from "../../session/types";
import { Organization } from "../../organizations/types";
import history from "../../../history";

interface OwnProps {
  patient: Patient | null;
  user: User | null;
  organization: Organization | null;
  setPatientAndAct: (patient: Patient, step: NavigationStep) => void;
  deactivatePatient: (patient: Patient) => void;
}

interface OwnState {
  submitDisabled: boolean;
}

type Props = OwnProps;

class PatientDetail extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true
    };

    this.deactivatePatient = this.deactivatePatient.bind(this);
  }

  private patientAction = (step: NavigationStep) => {
    if (this.props.patient) {
      this.props.setPatientAndAct(this.props.patient, step);
    }
  };

  private deactivatePatient = () => {
    if (this.props.patient) {
      this.props.deactivatePatient(this.props.patient);
    }
  };

  public render() {
    const { patient, user, organization } = this.props;
    return (
      <>
        <div className="section p-15">
          <div className="flex-column">
            <div className="title">
              Patient: {patient?.givenName} {patient?.familyName}
            </div>

            {patient && !patient?.isActive && <div className="mt-20 mb-20 inactive">Inactive</div>}

            <div className="columns">
              <div className="flex-1">
                {patient?.location && (
                  <div className="detail-entry">
                    <label htmlFor="location">Location</label>
                    <div id="location">{patient?.location}</div>
                  </div>
                )}

                {patient?.dateOfBirth && patient?.dateOfBirth.isValid() && (
                  <div className="detail-entry">
                    <label htmlFor="dob">Date of Birth</label>
                    <div id="dob">
                      <DobAgeProvider dob={patient?.dateOfBirth} />
                    </div>
                  </div>
                )}

                {patient?.email && (
                  <div className="detail-entry">
                    <label htmlFor="mrn">Email</label>
                    <div id="mrn">{patient?.email}</div>
                  </div>
                )}

                {patient?.mrn && (
                  <div className="detail-entry">
                    <label htmlFor="mrn">MRN</label>
                    <div id="mrn">{patient?.mrn}</div>
                  </div>
                )}

                {patient?.accountId && (
                  <div className="detail-entry">
                    <label htmlFor="AccountId">Account Id</label>
                    <div id="AccountId">{patient?.accountId}</div>
                  </div>
                )}

                {patient?.phone && (
                  <div className="detail-entry">
                    <label htmlFor="phonenumber">Phone Number</label>
                    <div id="phonenumber">
                      <PhoneNumberDisplay phonenumber={patient?.phone} />
                    </div>
                  </div>
                )}
                {canManagePatients(user) && (
                  <Link to={`/patient/${patient?.id}/edit/`}>
                    <button className="btn-link mt-20">Update patient information</button>
                  </Link>
                )}

                {canManagePatients(user) && patient && patient?.isActive && (
                  <button className="btn-link mt-10" onClick={this.deactivatePatient}>
                    Deactivate Patient
                  </button>
                )}
              </div>
              <div className="actions">
                <div className="bold">Communicate</div>
                <button
                  className="mt-10"
                  disabled={organization?.smsCommunicationDisabled}
                  onClick={() => this.patientAction(NavigationStep.MessagePatient)}
                >
                  <i className="fal fa-comment-alt-lines mr-5"></i> Message Patient
                </button>
                <button
                  className="mt-10"
                  disabled={organization?.smsCommunicationDisabled}
                  onClick={() => this.patientAction(NavigationStep.MessageFamily)}
                >
                  <i className="fal fa-comment-alt-lines mr-5"></i> Message Family
                </button>
                {user && user.featureFlags?.enableVideo && (
                  <button
                    className="mt-10"
                    disabled={organization?.smsCommunicationDisabled}
                    onClick={() => this.patientAction(NavigationStep.VideoChatSms)}
                  >
                    <i className="fas fa-video mr-5"></i> Text Video Visit Invite
                  </button>
                )}
                {user &&
                  user.featureFlags?.enableVideo &&
                  (patient?.email ?? "" !== "") &&
                  organization?.enableSendingEmail && (
                    <button
                      className="mt-10"
                      onClick={() => this.patientAction(NavigationStep.VideoChatEmail)}
                    >
                      <i className="fas fa-video mr-5"></i> Email Video Visit Invite
                    </button>
                  )}
                {user && user.featureFlags?.enableVideo && (
                  <button
                    className="mt-10"
                    disabled={organization?.smsCommunicationDisabled}
                    onClick={() => history.push(`/patient/${patient?.id}/family/`)}
                  >
                    <i className="fas fa-video mr-5"></i> Video Visit with Family
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PatientDetail;
